import {Component, ViewChild} from "@angular/core";
import {IVanService} from "../../../../../domain/leasing/IVanService";
import {Leasings} from "../../../../../../../../server/src/base/entities/leasing/Leasings";
import {RemoveDisabledVanDecorator} from "../../../../../infrastructure/leasing/RemoveDisabledVanDecorator";
import {UserReservationUserEditComponent} from "./userReservation/userReservationUserEdit";

/**
 * Created by Benoit Valkenberg on 16-12-17.
 */
@Component({
    selector: 'leasing-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class LeasingPresentationComponent {

    @ViewChild('userReservationDialog') public userReservationDialog:UserReservationUserEditComponent;

    private vanService:IVanService;
    public leasings:Leasings;

    constructor(vanService: IVanService) {
        this.vanService = new RemoveDisabledVanDecorator(vanService);
        this.leasings = new Leasings();
    }

    ngOnInit(){
        this.vanService.Leasings().then(leasings => {
            this.leasings = leasings;
        });
    }

    public openUserReservationDialog(event:any){
        this.vanService.Vans(event).then(vans => {
            if(vans.Value().length > 0){
                this.userReservationDialog.Open(vans);
            }
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/presentation.ts